import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavComponent } from '../../core/shared/components/nav/nav.component';

@Component({
  selector: 'app-adminstrator',
  standalone: true,
  templateUrl: './adminstrator.component.html',
  styleUrl: './adminstrator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavComponent, RouterOutlet],
})
export class AdminstratorComponent {}
